import { ENDPOINT } from './constants';
import { RequestAPI } from './Requests';

export const GeocoderRequests = {
  reverseGeocode: ({ lat, lng }: GeoCoordinates) =>
    RequestAPI.get(ENDPOINT.geocoder.reverseGeocode, { lat, long: lng }),
};
